import { Component, Input } from "@angular/core";

@Component({
  selector: "app-content-message",
  templateUrl: "./content-message.component.html",
  styleUrls: ["./content-message.component.scss"],
})
export class ContentMessageComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() description: string;
  @Input() cssClass: string;
}
